import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginModalComponent } from '@app/_v2/template/modals/login/login-modal.component';
import { ForgotPasswordModalComponent } from '@app/_v2/template/modals/forgot-password/forgot-password-modal.component';
import { ResetPasswordModalComponent } from '@app/_v2/template/modals/reset-password/reset-password-modal.component';
import { SignupStep1ModalComponent } from '@app/_v2/template/modals/signup/1/signup-modal.component';
import { AuthenticationGuard } from '@app/core';
import { SignupStep2ModalComponent } from '@app/_v2/template/modals/signup/2/signup-modal.component';
import { SignupStep3ModalComponent } from '@app/_v2/template/modals/signup/3/signup-modal.component';
import { SignupStep4ModalComponent } from '@app/_v2/template/modals/signup/4/signup-modal.component';
import { DepositModalComponent } from '@app/_v2/template/modals/deposit/deposit-modal.component';
import { WithdrawModalComponent } from '@app/_v2/template/modals/withdraw/withdraw-modal.component';
import { FairnessModalComponent } from '@app/_v2/template/modals/fairness/fairness-modal.component';
import { PageNotFoundComponent } from '@app/shared/components/page-not-found.component';
import { RedirectComponent } from '@app/redirect.component';
import { OnlyGuestGuard } from '@app/core/authentication/only-guest.guard';
import { NotificationsModalComponent } from '@app/_v2/template/modals/notifications/notifications-modal.component';
import { CountryRegistrationRestrictionGuard } from '@app/country-restriction/country-registration-restriction.guard';
import { JackpotKeysModalComponent } from '@app/_v2/template/modals/jackpot-keys/jackpot-keys-modal.component';
import { OpenChestNewModalComponent } from '@app/_v2/template/modals/open-chest-new/open-chest-modal.component';
import { JackpotFairnessModalComponent } from '@app/_v2/template/modals/jackpot-fairness/jackpot-fairness-modal.component';
import { GameRulesModalComponent } from '@app/_v2/template/modals/game-rules/game-rules-modal.component';
import { WithdrawalModalGuard } from '@app/_v2/template/modals/withdraw/withdraw-modal.guard';
import { VerifyPhoneModalComponent } from '@app/_v2/template/modals/signup/verify-phone/verify-phone-modal.component';
import { ImpersonateComponent } from '@app/impersonate.component';
import { ConfirmWithdrawalModalComponent } from '@app/_v2/template/modals/confirm-withdrawal/confirm-withdrawal-modal.component';
import { AuthenticationWithUserGuard } from '@app/core/authentication/authentication-with-user.guard';
import { DepositModal2Component } from '@app/_v2/template/modals/deposit/deposit-modal-2.component';
import { WithdrawModal2Component } from '@app/_v2/template/modals/deposit/withdraw-modal-2.component';

const routes: Routes = [
  { path: '', component: RedirectComponent, pathMatch: 'full' },
  { path: 'impersonate', component: ImpersonateComponent },
  {
    path: 'login',
    canActivate: [OnlyGuestGuard, CountryRegistrationRestrictionGuard],
    component: LoginModalComponent,
    outlet: 'modal',
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordModalComponent,
    // canActivate: [OnlyGuestGuard],
    outlet: 'modal',
  },
  {
    path: 'reset-password',
    component: ResetPasswordModalComponent,
    // canActivate: [OnlyGuestGuard],
    outlet: 'modal',
  },
  {
    path: 'confirm-withdrawal',
    component: ConfirmWithdrawalModalComponent,
    // canActivate: [OnlyGuestGuard],
    outlet: 'modal',
  },
  {
    path: 'signup',
    component: SignupStep1ModalComponent,
    canActivate: [CountryRegistrationRestrictionGuard],
    outlet: 'modal',
  },
  {
    path: 'signup-verify',
    canActivate: [AuthenticationGuard, CountryRegistrationRestrictionGuard],
    component: SignupStep2ModalComponent,
    outlet: 'modal',
  },
  {
    path: 'signup-kyc',
    canActivate: [AuthenticationGuard, CountryRegistrationRestrictionGuard],
    component: SignupStep3ModalComponent,
    outlet: 'modal',
  },
  {
    path: 'signup-confirming',
    canActivate: [AuthenticationGuard, CountryRegistrationRestrictionGuard],
    component: SignupStep4ModalComponent,
    outlet: 'modal',
  },
  {
    path: 'phone-verify',
    canActivate: [AuthenticationGuard, CountryRegistrationRestrictionGuard],
    component: VerifyPhoneModalComponent,
    outlet: 'modal',
  },
  {
    path: 'deposit',
    canLoad: [AuthenticationGuard],
    canActivate: [CountryRegistrationRestrictionGuard],
    component: DepositModal2Component,
    outlet: 'modal',
  },
  {
    path: 'withdraw',
    canActivate: [AuthenticationWithUserGuard, CountryRegistrationRestrictionGuard, WithdrawalModalGuard],
    component: WithdrawModal2Component,
    outlet: 'modal',
  },
  {
    path: 'fairness',
    component: FairnessModalComponent,
    outlet: 'modal',
  },
  {
    path: 'fairness/:id',
    component: FairnessModalComponent,
    outlet: 'modal',
  },
  /*{
    path: 'balance-switcher',
    canActivate: [AuthenticationGuard],
    component: BalanceSwitcherModalComponent,
    outlet: 'modal',
  },*/
  /*{
    path: 'open-chest',
    canActivate: [AuthenticationGuard],
    component: OpenChestModalComponent,
    outlet: 'modal',
  },*/
  {
    path: 'open-chest',
    canActivate: [AuthenticationGuard],
    component: OpenChestNewModalComponent,
    outlet: 'modal',
  },
  {
    path: 'notifications',
    canActivate: [AuthenticationGuard],
    component: NotificationsModalComponent,
    outlet: 'modal',
  },
  {
    path: 'jackpot-keys',
    component: JackpotKeysModalComponent,
    outlet: 'modal',
  },
  {
    path: 'jackpot-fairness',
    component: JackpotFairnessModalComponent,
    outlet: 'modal',
  },
  {
    path: 'game-rules',
    component: GameRulesModalComponent,
    outlet: 'modal',
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    outlet: 'modal',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/app-routing.module.ts